import React from 'react';
var AgentKpis = function AgentKpis(_ref) {
  var kpis = _ref.kpis;
  if (!kpis) {
    return null;
  }
  var totalNumberOfActiveListingsObjects = kpis.totalNumberOfActiveListingsObjects,
    percentageOfObjectsForBuy = kpis.percentageOfObjectsForBuy;
  return /*#__PURE__*/React.createElement("div", {
    className: "grid-flex gutter-l",
    "data-testid": "agent-kpis"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid-item grid-flex",
    "data-testid": "totalNumberOfActiveListingsObjects"
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-heading-xsmall-bold margin-right-xs"
  }, totalNumberOfActiveListingsObjects === null || totalNumberOfActiveListingsObjects === void 0 ? void 0 : totalNumberOfActiveListingsObjects.toLocaleString('de-De')), /*#__PURE__*/React.createElement("p", {
    className: "padding-top-xs"
  }, "Inserate")), /*#__PURE__*/React.createElement("div", {
    className: "grid-item grid-flex vertical-center",
    "data-testid": "percentageOfObjectsForBuy"
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-heading-xsmall-bold margin-right-xs"
  }, percentageOfObjectsForBuy.toLocaleString('de-De'), "%"), /*#__PURE__*/React.createElement("p", {
    className: "padding-top-xs"
  }, " zum Kauf")));
};
export default AgentKpis;